import { render, staticRenderFns } from "./a-image.vue?vue&type=template&id=83a16104&"
import script from "./a-image.vue?vue&type=script&lang=js&"
export * from "./a-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports